import { render, staticRenderFns } from "./Commerce.vue?vue&type=template&id=11b099ca&scoped=true&"
import script from "./Commerce.vue?vue&type=script&lang=js&"
export * from "./Commerce.vue?vue&type=script&lang=js&"
import style0 from "./Commerce.vue?vue&type=style&index=0&id=11b099ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b099ca",
  null
  
)

export default component.exports